import Loader from '@/components/Loader/Loader';
export default Loader;
